<div id="popup-modal" tabindex="-1" class="overflow-y-auto overflow-x-hidden top-0 right-0 left-0 z-50 md:inset-0 h-modal md:h-full">
  <div class="relative w-[370px] lg:w-[590px] h-full md:h-auto">
    <div class="relative bg-neutral-06 rounded-lg shadow dark:bg-gray-700">
      <div
        (click)="onClose()"
        class="absolute z-50 cursor-pointer top-1 right-4 lg:top-4 focus:boder-0 lg:right-4 text-gray-400 bg-transparent hover:bg-gray-200
          hover:text-gray-900 rounded-lg text-sm p-2 ml-auto inline-flex items-center"
        data-modal-toggle="popup-modal"
      >
        <svg
          class="text-neutral-06 stroke-white hidden lg:block"
          width="32"
          stroke="currentColor"
          height="33"
          viewBox="0 0 32 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M27.0635 5.49365L5.23599 28.4268" stroke="#666" stroke-width="1.5" stroke-linecap="round" />
          <path d="M27.0635 28.4269L5.23599 5.49369" stroke="#666" stroke-width="1.5" stroke-linecap="round" />
        </svg>
        <svg class="block z-50 lg:hidden" width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M27.0635 5.49365L5.23599 28.4268" stroke="#fff" stroke-width="1.5" stroke-linecap="round" />
          <path d="M27.0635 28.4269L5.23599 5.49369" stroke="#fff" stroke-width="1.5" stroke-linecap="round" />
        </svg>
        <span class="sr-only">Close modal</span>
      </div>

      <div class="">
        <div class="relative bg-neutral-06">
          <p class="text-xl md:text-4xl text-primary font-bold text-center pt-16">
            {{ 'ERROR_MESSAGE' | translate }}
          </p>
          <hr class="border-black my-5 mx-[30px]" />
          <div class="flex justify-center">
            <svg width="116" height="121" viewBox="0 0 116 121" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M57.5 105C78.2107 105 95 88.2107 95 67.5C95 46.7893 78.2107 30 57.5 30C36.7893 30 20 46.7893 20 67.5C20 88.2107 36.7893 105 57.5 105Z"
                stroke="#00A54C"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M57.5 114C83.1812 114 104 93.1812 104 67.5C104 41.8188 83.1812 21 57.5 21C31.8188 21 11 41.8188 11 67.5C11 93.1812 31.8188 114 57.5 114Z"
                stroke="#00A54C"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-dasharray="8 8"
              />
              <path
                d="M108.5 33C110.433 33 112 31.433 112 29.5C112 27.567 110.433 26 108.5 26C106.567 26 105 27.567 105 29.5C105 31.433 106.567 33 108.5 33Z"
                stroke="#DBAB27"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6 119C8.20914 119 10 117.209 10 115C10 112.791 8.20914 111 6 111C3.79086 111 2 112.791 2 115C2 117.209 3.79086 119 6 119Z"
                stroke="#DBAB27"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path d="M17 7L7 7" stroke="#DBAB27" stroke-width="2.5" stroke-linecap="round" />
              <path d="M12 12L12 2" stroke="#DBAB27" stroke-width="2.5" stroke-linecap="round" />
              <path d="M68.3145 79.314L45.687 56.6865" stroke="#00A54C" stroke-width="3" stroke-linecap="round" />
              <path d="M45.6875 79.314L68.3149 56.6865" stroke="#00A54C" stroke-width="3" stroke-linecap="round" />
              <path d="M114 113H104" stroke="#00A54C" stroke-width="2.5" stroke-linecap="round" />
              <path d="M109 118L109 108" stroke="#00A54C" stroke-width="2.5" stroke-linecap="round" />
              <path d="M12 98.5H7" stroke="#00A54C" stroke-width="2.5" stroke-linecap="round" />
              <path d="M9.5 101L9.5 96" stroke="#00A54C" stroke-width="2.5" stroke-linecap="round" />
            </svg>
          </div>

          <p class="text-sm md:text-base text-neutral-01 mt-8 text-center">
            {{ 'REGISTRATION_FAILED' | translate }}<br />
            {{ 'PLEASE_TRY_AGAIN_LATER' | translate }}
          </p>

          <div class="mt-5 pb-12 flex justify-center">
            <button class="bg-primary color-white font-medium flex items-center py-3 px-8" (click)="tryAgain()">
              {{ 'TRY_AGAIN' | translate }}
              <img class="ml-3" src="/assets/svg/ic-arrow-right.svg" alt="ic-arrow-right" loading="lazy" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
